import { ClientsTab, TechniciansTab } from "../components";
import {
  Heading,
  HStack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";

export default function Users() {
  const dataTableStyles = {
    headRow: {
      style: {
        borderBottomWidth: "0px",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    rows: {
      style: {
        borderRadius: "15px",
        boxShadow: "1px 2px 6px 0px rgb(0,0,0,0.1)",
        marginBottom: "10px",
        "&:not(:last-of-type)": {
          borderBottomWidth: "0px",
        },
      },
    },
    pagination: {
      style: {
        borderTopWidth: "0px",
      },
    },
  };

  return (
    <>
      <HStack
        justifyContent="space-between"
        alignItems={{ base: "start", md: "center" }}
        flexDirection={{ base: "column", md: "row" }}
        mb={4}
      >
        <Heading fontSize={{ base: "xl", md: "3xl" }}>Users</Heading>
      </HStack>
      <Tabs variant="unstyled">
        <TabList borderBottomWidth="2px" borderColor="primary.main">
          <Tab
            borderWidth="2px"
            borderBottomWidth="0"
            borderColor="gray.300"
            borderTopLeftRadius="10px"
            borderTopRightRadius="10px"
            color="gray.400"
            fontWeight="bold"
            _selected={{
              borderColor: "primary.main",
              color: "primary.main",
            }}
          >
            Clients
          </Tab>
          <Tab
            borderWidth="2px"
            borderBottomWidth="0"
            borderColor="gray.300"
            borderTopLeftRadius="10px"
            borderTopRightRadius="10px"
            color="gray.400"
            fontWeight="bold"
            _selected={{
              borderColor: "primary.main",
              color: "primary.main",
            }}
          >
            Technicians
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ClientsTab customStyles={dataTableStyles} />
          </TabPanel>
          <TabPanel>
            <TechniciansTab customStyles={dataTableStyles} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}
